import { z } from 'zod';
import { requiredFieldSchema } from './fields';

export const postManualSchema = (t) =>
  z.object({
    name: requiredFieldSchema(t('error.machineGroupManualNameRequired')),
    description: requiredFieldSchema(t('error.machineGroupManualDescriptionRequired')),
    file: z.any().refine((file) => !!file, t('error.machineGroupManualFileRequired')),
  });
